<div class="main-container">
  <div class="referidos-content row">
    <h1>Consulta seguimiento referidos</h1>
    <span style="font-size: medium; color: var(--mid-gray-color)">
      Ingrese los datos del referido en los campos de búsqueda para generar la
      consulta. En caso de necesitar ayuda, comuníquese al correo
      masamigosmasbienestar_mp&#64;coomeva.com.co.
    </span>
    <br /><br /><br />
    <form [formGroup]="frmReferidos">
      <!-- DIV GENERAL -->
      <div class="form-container row">
        <!-- Primer DIV -->
        <div class="col-8">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo de identificación</mat-label>
                <mat-select formControlName="tipo_identificacion">
                  <mat-option *ngFor="let t of tipo_id" [value]="t.codigo">
                    {{ t.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- No. de Identificación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Número de identificación</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="identificacion"
                  maxlength="20"
                />
                <mat-error *ngIf="hasError(getControl['identificacion'])">
                  {{
                    printError(getControl["identificacion"], {
                      noSpaces: "No se permite espacios"
                    })
                  }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Segundo DIV: Botones -->
        <div class="col-4">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <button
                type="submit"
                class="btn btn-primary btn-icon"
                (click)="consultar()"
                appTrackClick
                [trackData]="trackDataCarnet"
              >
                <mat-icon>search</mat-icon><span>CONSULTAR</span>
              </button>
            </div>

            <div class="col-12 col-md-6 col-lg-5">
              <button
                type="button"
                class="btn btn-primary btn-icon"
                (click)="clear()"
              >
                <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Tabla de resultados -->
    <div *ngIf="haveResponde && haveDataToShow">
      <div class="mat-elevation-z2 mt-4 table-scroll-container">
        <div class="table-scroll"> 
        <table mat-table [dataSource]="dataSource" class="w-100 bordered-table">
          <!-- Nombre referido -->
          <ng-container matColumnDef="nombreReferido">
            <th mat-header-cell *matHeaderCellDef>Nombre referido</th>
            <td mat-cell *matCellDef="let row">{{ row.nombreReferido }}</td>
          </ng-container>

          <!-- Tipo doc referido -->
          <ng-container matColumnDef="tipoDocReferido">
            <th mat-header-cell *matHeaderCellDef>Tipo documento referido</th>
            <td mat-cell *matCellDef="let row">{{ row.tipoDocReferido }}</td>
          </ng-container>

          <!-- Número doc referido -->
          <ng-container matColumnDef="numDocReferido">
            <th mat-header-cell *matHeaderCellDef>Número documento referido</th>
            <td mat-cell *matCellDef="let row">{{ row.numDocReferido }}</td>
          </ng-container>

          <!-- Programa -->
          <ng-container matColumnDef="programa">
            <th mat-header-cell *matHeaderCellDef>Programa</th>
            <td mat-cell *matCellDef="let row">{{ row.programa }}</td>
          </ng-container>

          <!-- Nombre referente -->
          <ng-container matColumnDef="nombreReferente">
            <th mat-header-cell *matHeaderCellDef>Nombre referente</th>
            <td mat-cell *matCellDef="let row">{{ row.nombreReferente }}</td>
          </ng-container>

          <!-- Tipo documento referente -->
          <ng-container matColumnDef="tipoDocReferente">
            <th mat-header-cell *matHeaderCellDef>Tipo documento referente</th>
            <td mat-cell *matCellDef="let row">{{ row.tipoDocReferente }}</td>
          </ng-container>

          <!-- Numero documento referente -->
          <ng-container matColumnDef="numDocReferente">
            <th mat-header-cell *matHeaderCellDef>
              Numero documento referente
            </th>
            <td mat-cell *matCellDef="let row">{{ row.numDocReferente }}</td>
          </ng-container>

          <!-- Estado pago -->
          <ng-container matColumnDef="estadoPago">
            <th mat-header-cell *matHeaderCellDef>
              Estado de pago del referente
            </th>
            <td mat-cell *matCellDef="let row">{{ row.estadoGestionPago }}</td>
          </ng-container>

          <!-- Observaciones -->
          <ng-container matColumnDef="observaciones">
            <th mat-header-cell *matHeaderCellDef>Observaciones</th>
            <td mat-cell *matCellDef="let row">{{ row.observaciones }}</td>
          </ng-container>

          <!-- Valor a pagar -->
          <ng-container matColumnDef="valoraPagar">
            <th mat-header-cell *matHeaderCellDef>Valor a pagar</th>
            <td mat-cell *matCellDef="let row">{{ row.valoraPagar }}</td>
          </ng-container>

          <!-- Fecha pago referente -->
          <ng-container matColumnDef="fechaPagoReferente">
            <th mat-header-cell *matHeaderCellDef>Fecha pago referente</th>
            <td mat-cell *matCellDef="let row">{{ row.fechaPagoReferente }}</td>
          </ng-container>

          <!-- Acciones -->
          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Acciones
            </th>
            <td mat-cell *matCellDef="let row" class="text-center">
              <span
                [matTooltip]="
                  row.tieneBeneficiarios
                    ? 'Información beneficiarios'
                    : 'No hay beneficiarios'
                "
                matTooltipShowDelay="300"
              >
                <button
                  mat-icon-button
                  [color]="row.tieneBeneficiarios ? 'primary' : 'warn'"
                  [disabled]="!row.tieneBeneficiarios"
                  (click)="abrirModal(row)"
                >
                  <mat-icon>info</mat-icon>
                </button>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        [pageSize]="5"
        [pageSizeOptions]="[5]"
        showFirstLastButtons
      >
      </mat-paginator>
      </div>
    </div>

    <div *ngIf="haveResponde && !haveDataToShow" class="message-container">
      <span class="message-span"> {{ generalMessage.toUpperCase() }}</span>
    </div>
  </div>
</div>
